// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__qZ9s4","darkMode":"styles_darkMode__rb4ay","activeTab":"styles_activeTab__f97LG"};